import { ErrorBoundary } from '@sentry/react';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v8';
import React, { Suspense, useEffect } from 'react';
import { RouterProvider } from 'react-aria-components';
import { Outlet, useLocation, useNavigate } from 'react-router';
import LoadingScreen from '~/components/LoadingScreen';
import ScrollToTop from '~/components/ScrollToTop';
import { ErrorBoundaryFallback } from '~/components/layout/ErrorBoundaryFallback';
import ToastProvider from '~/hooks/ToastProvider';
import { useAnalytics } from '~/hooks/useAnalytics';
import useExceptionLogger from '~/hooks/useExceptionLogger';
import { ModalProvider } from '~/modals/Modal';

const AppRoot: React.FunctionComponent = () => {
  const { page } = useAnalytics();
  const location = useLocation();
  const { decorateScopeContexts } = useExceptionLogger();
  const navigate = useNavigate();

  useEffect(() => page(), [location.pathname, location.search, page]);

  return (
    <NuqsAdapter>
      <ScrollToTop />
      <ToastProvider />
      <ModalProvider>
        <Suspense fallback={<LoadingScreen />}>
          <ErrorBoundary
            beforeCapture={(scope, error) => {
              decorateScopeContexts(scope, error);
            }}
            fallback={ErrorBoundaryFallback}
          >
            <RouterProvider navigate={navigate}>
              <Outlet />
            </RouterProvider>
          </ErrorBoundary>
        </Suspense>
      </ModalProvider>
    </NuqsAdapter>
  );
};

export default AppRoot;
